import { render, staticRenderFns } from "./PopupBuilder.vue?vue&type=template&id=8c7c3e1a&scoped=true"
import script from "./PopupBuilder.vue?vue&type=script&lang=js"
export * from "./PopupBuilder.vue?vue&type=script&lang=js"
import style0 from "./PopupBuilder.vue?vue&type=style&index=0&id=8c7c3e1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7c3e1a",
  null
  
)

export default component.exports